import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { customAuthAxios } from '../../utils/customAuthAxios';
import { useErrorToast } from '../toast/useErrorToast';
import { useUpdateFirstView } from './useUpdateFirstView';

export const useSubmitMyRestaurantEdit = (userId?: string, restaurantId?: string) => {
  const showErrorToast = useErrorToast();
  const navigate = useNavigate();
  const updateFirstView = useUpdateFirstView();

  const editUser = useCallback(async (userData: any) => {
    const response = await customAuthAxios.put(`accounts/users/${userId}/`, userData);
    return response;
  }, [userId]);

  const editRestaurant = useCallback(async (restaurantData: any) => {
    const uploadData = new FormData();
    const fields = ["name", "address", "manager_last_name", "manager_first_name", "manager_phone_number"];

    fields.forEach(field => {
      if (restaurantData[field] !== undefined && restaurantData[field] !== null) {
        uploadData.append(field, restaurantData[field]);
        console.log(`FormDataに追加: ${field} = ${restaurantData[field]}`);
      }
    });

    if (restaurantData.logo && restaurantData.logo[0]) {
      uploadData.append("logo", restaurantData.logo[0], restaurantData.logo[0].name);
    }

    const response = await customAuthAxios.put(`accounts/restaurants/${restaurantId}/`, uploadData);
    return response;
  }, [restaurantId]);

  const onSubmit = useCallback(async (data: any) => {
    try {

      await editUser(data.user);
      await editRestaurant(data.restaurant);

      // 開始画面の更新を別途実行（空や未選択の場合も含む）
      if (restaurantId) {
        // restaurant_idからハイフンを除去（APIに合わせて）
        const restaurantIdWithoutHyphens = restaurantId.replace(/-/g, '');
        
        // 開始画面が設定されていない場合は空文字列を送信
        const startPageValue = data.restaurant.start_page || '';
        await updateFirstView(restaurantIdWithoutHyphens, startPageValue);
      }

      navigate(-1);
    } catch (error: any) {
      console.error('=== 保存エラー ===');
      console.error('エラーオブジェクト:', error);
      console.error('レスポンスデータ:', error.response?.data);
      console.error('レスポンスステータス:', error.response?.status);

      if (error.response && error.response.data && error.response.data.username) {
        showErrorToast(error.response.data.username);
      } else {
        showErrorToast('保存中にエラーが発生しました');
      }
    }
  }, [navigate, showErrorToast, editUser, editRestaurant, updateFirstView, restaurantId]);

  return onSubmit;
};